import React, { ComponentPropsWithoutRef, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import coralIcon from '../../assets/images/coral-wordmark.png';
import smallCoralIcon from '../../assets/images/coral-short-wordmark.png';
import { AuthContext } from '../Auth/AuthContext/AuthContext';
import { getTicketsUrl } from '../../utils/ticketsUrl';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface HeaderProps extends ComponentPropsWithoutRef<any> {
  navigationTextHandler: string;
  /** Header surface classes (background + any text colour). Defaults to the
   *  white production header; routes pass their own via App's
   *  handleHeaderColor so the editorial routes can opt into a warm surface
   *  without colliding with a hardcoded background. */
  background?: string;
}

const Header: React.FC<HeaderProps> = ({ navigationTextHandler, background = 'bg-white', ...props }) => {
  const { setShowAuth, currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleClick = () => {
    if (currentUser) {
      // If user is authenticated, redirect to dashboard
      navigate('/dashboard');
    } else {
      setShowAuth({ show: true, signIn: false }); // Show authentication modal immediately
    }
  };

  return (
    <header className={background} {...props}>
      <div className="px-4 py-4 max-w-screen-xl mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-4 sm:space-x-8">
          <Link to="/" className="flex items-center space-x-2">
            <img src={coralIcon} alt="Coral" className="mr-1 h-11 hidden sm:block" />
            <div className="flex flex-col">
              <img src={smallCoralIcon} alt="Small Coral" className="block sm:hidden h-11" />
            </div>
          </Link>
        </div>
        <div className="flex items-center space-x-4 sm:space-x-8">

          <a
            href="https://instagram.com/wearecoral"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="wearecoral on Instagram"
            className="hidden sm:block hover:text-coral-pink transition-colors duration-200"
          >
            <Instagram size={24} aria-hidden="true" />
          </a>
          <Link
            to="/manifesto"
            className={`hidden sm:block ${navigationTextHandler} font-syne whitespace-nowrap`}
          >
            Manifesto
          </Link>
          <a
            href={getTicketsUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className={`${navigationTextHandler} font-syne whitespace-nowrap`}
          >
            Tickets
          </a>
          <Link to="/for-artists" className={`${navigationTextHandler} font-syne whitespace-nowrap`}>
            For Artists
          </Link>
          <button onClick={handleClick} className={`pr-2 sm:pr-0 font-syne md:inline ${navigationTextHandler}`}>
            Sign In
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;